import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "../../../components/dashboard/dashboardHeader";
import { ModuleFilter } from "../../../components/utils/ModuleFilter";
import { getCountsAsync } from "../../../slices/inventory/count";
import { InventoryCountsTable } from "../../../components/dashboard/inventory/counts/inventory-counts-table";
import { PlusIcon } from "@heroicons/react/24/outline";

export const InventoryCounts = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const itemState = useSelector((store) => {
    return store.inventory_counts;
  });

  const { isLoading, data, itemsCount } = itemState;
  const [filters, setFilters] = useState({
    query: "",
    statuses: [],
  });
  const [controller, setController] = useState({
    filters: [],
    page: 1,
    query: "",
    sort: "desc",
    sortBy: "updated_at",
    view: "all",
    per_page: 10,
  });

  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setController({
      ...controller,
      page: 1,
      query: newFilters.query || "",
      filters: newFilters.statuses || [],
    });
  };

  const handlePageChange = (newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleItemsSelect = (selectedItems) => {
    // Handle selected items if needed
  };

  // Convert ModuleFilter format to backend format
  const getPayload = useMemo(() => {
    return {
      filters: filters.statuses || [],
      status: filters.statuses || [],
      page: controller.page,
      query: filters.query || "",
      sort: controller.sort,
      sortBy: controller.sortBy,
      view: controller.view,
      per_page: controller.per_page,
    };
  }, [filters, controller]);

  useEffect(() => {
    dispatch(getCountsAsync(getPayload));
  }, [dispatch, getPayload]);

  const headerActions = [
    {
      component: null,
      label: t("inventory.count.create"),
      description: "",
      path: "/dashboard/inventory/counts/new",
      icon: PlusIcon,
      textColor: "text-white",
      bgColor: "bg-blue-600",
      hidden: false,
      menu: false,
    },
  ];

  return (
    <DashboardHeader
      title={t("inventory.counts.title")}
      subtitle={t("inventory.counts.description")}
      actions={headerActions}
    >
      <div className="mx-auto mt-8 grid max-w-3xl grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
        <div className="space-y-6 lg:col-span-3 lg:col-start-1 sm:col-span-3">
          <ModuleFilter
            className={"mt-10"}
            disabled={isLoading}
            onFiltersChange={handleFiltersChange}
            initialFilters={filters}
            acceptedStatuses={["draft", "pending_approval", "approved", "completed"]}
            searchPlaceholder={t("inventory.counts.search_placeholder")}
            filterTitle={t("inventory.counts.filter_title")}
          />

          <InventoryCountsTable
            itemState={itemState}
            itemsCount={itemsCount || 0}
            currentCount={data?.length}
            page={controller.page}
            perPage={controller.per_page}
            onPageChange={handlePageChange}
            onItemsSelect={handleItemsSelect}
          />
        </div>
      </div>
    </DashboardHeader>
  );
};